import { RequestCreateActionProcessDTO, RequestDetailsDTO, UserStateDTO } from 'cca-api';

export interface WorkflowDisplayContent {
  title: string;
  button: string;
  hint?: string;
  type: RequestCreateActionProcessDTO['requestType'];
  errors: string[];
}

export const processActionsDetailsTypesMap: Partial<Record<RequestDetailsDTO['requestType'], string>> = {
  FACILITY_AUDIT: 'facility audit',
  ADMIN_TERMINATION: 'admin Termination',
  UNDERLYING_AGREEMENT_VARIATION: 'variation',
  NON_COMPLIANCE: 'non-compliance',
  PERFORMANCE_DATA_DOWNLOAD: 'download performance data',
  PERFORMANCE_DATA_UPLOAD: 'upload performance data',
  PERFORMANCE_ACCOUNT_TEMPLATE_DATA_UPLOAD: 'upload PAT spreadsheets',
  CCA3_EXISTING_FACILITIES_MIGRATION_ACCOUNT_PROCESSING: 'CCA3 Migration',
  PERFORMANCE_DATA_FACILITY_DIGITAL_FORM: 'TP reporting',
  PERFORMANCE_DATA_FACILITY_DATA_UPLOAD: 'TP reporting (TP7, TP8, TP9)',
};

export const userRoleWorkflowAccessMap: Record<UserStateDTO['roleType'], string[]> = {
  REGULATOR: ['FACILITY_AUDIT', 'ADMIN_TERMINATION', 'UNDERLYING_AGREEMENT_VARIATION', 'NON_COMPLIANCE'],
  OPERATOR: ['FACILITY_AUDIT'],
  SECTOR_USER: [
    'UNDERLYING_AGREEMENT_VARIATION',
    'PERFORMANCE_DATA_DOWNLOAD',
    'PERFORMANCE_DATA_UPLOAD',
    'PERFORMANCE_ACCOUNT_TEMPLATE_DATA_UPLOAD',
    'PERFORMANCE_DATA_FACILITY_DIGITAL_FORM',
    'PERFORMANCE_DATA_FACILITY_DATA_UPLOAD',
  ],
  VERIFIER: [],
};

export const taskWorkflowContentDisplayMap: Record<RequestDetailsDTO['requestType'], WorkflowDisplayContent> = {
  FACILITY_AUDIT: {
    title: 'Audit facility',
    button: 'Start audit task',
    hint: 'Start an audit task for this facility',
    type: 'FACILITY_AUDIT',
    errors: [],
  },
  ADMIN_TERMINATION: {
    title: 'Admin termination',
    button: 'Start admin termination',
    hint: 'Terminate the underlying agreement. The target unit account will be closed once the admin termination is complete.',
    type: 'ADMIN_TERMINATION',
    errors: [],
  },
  UNDERLYING_AGREEMENT_VARIATION: {
    title: 'Make a permanent change to the underlying agreement',
    button: 'Start a variation',
    type: 'UNDERLYING_AGREEMENT_VARIATION',
    errors: [],
  },
  NON_COMPLIANCE: {
    title: 'Non-compliance',
    hint: 'Start a non-compliance task to record enforcement decisions relevant to this target unit.',
    button: 'Start non-compliance task',
    type: 'NON_COMPLIANCE',
    errors: [],
  },
  PERFORMANCE_DATA_DOWNLOAD: {
    title: 'TP reporting (TP6) - Download spreadsheets',
    hint: 'Generate a zip file that contains the TPR spreadsheets. You will be able to edit the data in the spreadsheets.',
    button: 'Start TPR spreadsheets download',
    type: 'PERFORMANCE_DATA_DOWNLOAD',
    errors: [],
  },
  PERFORMANCE_DATA_UPLOAD: {
    title: 'TP reporting (TP6) - Upload spreadsheets',
    button: 'Start TPR spreadsheets upload',
    type: 'PERFORMANCE_DATA_UPLOAD',
    errors: [],
  },
  PERFORMANCE_ACCOUNT_TEMPLATE_DATA_UPLOAD: {
    title: 'Upload PAT spreadsheets',
    button: 'Start PAT Spreadsheets upload',
    type: 'PERFORMANCE_ACCOUNT_TEMPLATE_DATA_UPLOAD',
    errors: [],
  },
  PERFORMANCE_DATA_FACILITY_DIGITAL_FORM: {
    title: 'TP reporting',
    hint: 'Start a target period (TP) reporting task using a form for TP7, TP8, TP9.',
    button: 'Start TP reporting task',
    type: 'PERFORMANCE_DATA_FACILITY_DIGITAL_FORM',
    errors: [],
  },
  PERFORMANCE_DATA_FACILITY_DATA_UPLOAD: {
    title: 'TP reporting (TP7, TP8, TP9) - Upload CSV file',
    hint: 'Start a TP reporting task for the whole sector using a CSV file for TP7, TP8, TP9.',
    button: 'Start TP reporting task',
    type: 'PERFORMANCE_DATA_FACILITY_DATA_UPLOAD',
    errors: [],
  },
};
